import { callOrganizationServiceApi } from '../../../apis/organizationService';

/**
 * Every organization the identity belongs to, with its four rate limits.
 *
 * @param {string} identityId - The identity's auth-service user id
 * @returns {Promise<import('../types').IGetMemberRateLimitsApiResponse>}
 */
export const getMemberRateLimits = (identityId) =>
  callOrganizationServiceApi('get', 'admin/organization-members/rate-limits', {
    params: { identityId },
  });
